import { render } from "./GetTwoFaPhone.vue?vue&type=template&id=78c5f3b7&scoped=true&ts=true"
import script from "./GetTwoFaPhone.vue?vue&type=script&lang=ts"
export * from "./GetTwoFaPhone.vue?vue&type=script&lang=ts"

import "./GetTwoFaPhone.vue?vue&type=style&index=0&id=78c5f3b7&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78c5f3b7"]])

export default __exports__